module.exports = __webpack_public_path__ + "c265f67b337ce9eda1012077444b3ea2.pdf";